// the access requirement for a route.
// integer-valued so gate checks are a simple comparison (see isGatedRoute).
export const AccessLevel = {
  // anyone may view: logged out, guest, or user.
  Public: 0,
  // requires a user session OR a valid guest (address cookie).
  UserOrGuest: 1,
  // requires a user session. guests are redirected.
  UserOnly: 2,
} as const

export type AccessLevel = (typeof AccessLevel)[keyof typeof AccessLevel]

// whether a route requires any access gate (user or guest)
export const isGatedRoute = (accessLevel: AccessLevel = AccessLevel.Public) =>
  accessLevel > AccessLevel.Public
